Namespace 'Settings.Models.AccountSettings.SocialAccounts'

class Settings.Models.AccountSettings.SocialAccounts.GoogleMyBusinessAccounts extends Backbone.Model
  urlRoot: '/auth/google_my_business/accounts'

  defaults:
    uid: '',
    name: '',
    type: 'ACCOUNT_TYPE_UNSPECIFIED'

Namespace 'Settings.Collections.AccountSettings.SocialAccounts'

class Settings.Collections.AccountSettings.SocialAccounts.GoogleMyBusinessAccounts extends Backbone.Collection
  url: '/auth/google_my_business/accounts'
  model: Settings.Models.AccountSettings.SocialAccounts.GoogleMyBusinessAccounts

  accounts: ->
    @models.map((model) -> {
      uid: model.get('uid')
      name: model.get('name')
      type: model.get('type')
    })
